import { configureStore } from "@reduxjs/toolkit";
import transactionSlice from "../features/transaction/transactionSlice";
import paginationSlice from "./../features/pagination/paginationSlice";
import filterSlice from "./../features/filter/filterSlice";

export const store = configureStore({
    reducer: {
        transaction: transactionSlice,
        pagination: paginationSlice,
        filter: filterSlice,
    },
});
